export default __webpack_public_path__ + "static/media/logo.d05f4e4e.png";